import React, { useState, useEffect } from 'react';
import './NewsletterBanner.css';

// Hardcoded reCAPTCHA site key
const RECAPTCHA_SITE_KEY = '6LeX2-opAAAAAHr45FWkOsMM5kF1iYZuz7VrUq6o';

const NewsletterBanner = ({ heading, paragraph }) => {
  const [email, setEmail] = useState('');

  const generateRecaptchaToken = async () => {
    return new Promise((resolve, reject) => {
      if (window.grecaptcha) {
        window.grecaptcha.ready(() => {
          window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'submit' })
            .then((token) => {
              resolve(token);
            })
            .catch((error) => {
              console.error('reCAPTCHA execution error (NewsletterBanner):', error);
              reject(error);
            });
        });
      } else {
        console.error('grecaptcha not defined (NewsletterBanner)');
        reject(new Error('grecaptcha not defined'));
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      console.error('Email is required');
      return;
    }

    try {
      // Generate a fresh reCAPTCHA token right before form submission
      const token = await generateRecaptchaToken();

      const response = await fetch('https://pharm-rx-backend-50d4ad87e02c.herokuapp.com/api/subscribe-newsletter', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: email, g_recaptcha_response: token }),
      });

      if (response.ok) {
        console.log('Subscription successful');
      } else {
        console.error('Subscription failed');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
    setEmail('');
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      if (!window.grecaptcha) {
        console.error('grecaptcha not defined (NewsletterBanner)');
      }
    };

    script.onerror = () => {
      console.error('Error loading reCAPTCHA script (NewsletterBanner)');
    };

    document.head.appendChild(script);
  }, []);

  return (
    <div className="newsletter-banner">
      <div className="newsletter-content">
        <h2>{heading}</h2>
        <p>{paragraph}</p>
        <form noValidate className="newsletter-form" onSubmit={handleSubmit}>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
          />
          <div id="recaptcha-container-newsletter"></div>
          <button type="submit">Subscribe</button>
        </form>
      </div>
    </div>
  );
};

export default NewsletterBanner;
